export default Object.freeze({
  GenerateTokenReadOnly: 1, // "generate-token-readonly"
  GenerateTokenWrite: 2, // "generate-token-write"
  AppendComponent: 3, // "append-component"
  ModifyComponent: 4, // "modify-component"
  RemoveComponent: 5, // "remove-component"
  Publish: 6, // "publish"
  NewVersionCreated: 7, // "new-version-created"
});
